import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';
import { EStage, EYesNo } from '../../../../shared/models/types.enum';
import { IReview, ITask } from '../../../../shared/models/review';
import { AssessScreenService } from '../../../../shared/services/assessScreen.service';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { UserDataService } from '../../../../shared/services/auth/userData.service';
import { ReviewService } from '../../../../shared/services/review.service';
import { ReviewAssessScreenComponent } from '../../review-content/review-assess-screen/review-assess-screen.component';
import { RejectionReasonComponent } from '../../rejection-reason/rejection-reason.component';

@Component({
  selector: 'evaluations-review-modal',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    ReviewAssessScreenComponent,
    RejectionReasonComponent
  ],
  templateUrl: './evaluations-review-modal.component.html',
  styleUrl: './evaluations-review-modal.component.css'
})
export class EvaluationsReviewModalComponent implements OnInit {

  icons = Icons;
  stageEnum = EStage;
  yesNo = EYesNo;
  assessScreen: any | null = null;
  currentBuildingId: string | null = null;

  showRejectionReason: boolean = false;

  @Input() task: ITask | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSend = new EventEmitter<{type: string, message: string}>();
  loading: boolean = false;

  constructor(
    private assessScreenService: AssessScreenService,
    private userDataService: UserDataService,
    private reviewService: ReviewService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();

    this.loadAssessScreen();
  }

  loadAssessScreen(): void {
    if (this.task?.case_id) {
      this.loading = true;      
      this.assessScreenService.getAssessScreenByCaseId(this.task.case_id).subscribe({
        next: (response) => {
          this.assessScreen = response;
          this.loading = false;
          this.showRejectionReason = false;
        },
        error: (error) => {
          console.error('Error fetching assess screen:', error);
          this.loading = false;
          this.showRejectionReason = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

  handleRejectionSubmit(noteFormValue: { note: string }): void {
    const note = noteFormValue.note;
    this.approveAssessmentScreen(this.yesNo.No, note);
  }

  approveAssessmentScreen(decision: string, note?: string): void {
    if (this.task && this.assessScreen) {
      this.loading = true;
      const data: IReview = {
        case_id: this.assessScreen.case_id,
        building_id: Number(this.currentBuildingId),
        section_review_type: this.stageEnum.Evaluations,
        approve: decision,
        note: note || ''
      };
      this.reviewService.reviewCompleted(data).subscribe({
        next: (response) => {
          this.loading = false;
          this.onSend.emit({type: 'success', message: 'This occurred after rejecting and approving a review.'});
        },
        error: (error) => {
          this.loading = false;
          console.error('Error completing review:', error);
          this.onSend.emit({type: 'failed', message: error.message});
        }
      });
    }
  }

  handleCloseReviewModal(): void {
    this.task = null;
    this.onClose.emit();
  }
}
